<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 表单查询 -->
    <div class="bg-white pdt-10 pdb-10">
      <el-form ref="form" :model="form" label-width="150px" :inline="true">
        <el-form-item label="团队名称">
          <el-input
            v-model="form.teamName"
            placeholder="请输入团队名称"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item label="组长">
          <el-select
            filterable
            clearable
            v-model="form.leader"
            placeholder="请选择"
          >
            <el-option
              v-for="(v, i) in userArr"
              :key="i"
              :label="v.name"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList()">查询</el-button>
          <el-button
            @click="
              form = { startTime: '', endTime: '' };
              getList();
            "
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="mgt-15 mgb-15">团队总数：{{ total }}</div>
    <btns class="mgb-20" @exec="exec"></btns>
    <!-- 表格 -->
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="departmentName" label="团队名称">
      </el-table-column>
      <el-table-column prop="groupName" label="组长"> </el-table-column>
      <el-table-column prop="departmentNum" label="组内成员数量">
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleDetail(scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>
    <!-- 新增编辑团队弹框 -->
    <el-dialog
      :title="funTit == 'add' ? '新增团队' : '编辑团队'"
      :visible.sync="addOrEditVisible"
      width="30%"
      center
      top="30vh"
      :close-on-click-modal="false"
    >
      <el-form
        :rules="rules"
        ref="addOrEditForm"
        :model="addOrEditForm"
        label-width="80px"
      >
        <el-form-item label="团队名称" prop="name">
          <el-input
            v-model="addOrEditForm.name"
            placeholder="请输入团队名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="组长" prop="leader" v-if="funTit == 'add'">
          <el-select
            filterable
            v-model="addOrEditForm.leader"
            placeholder="请选择组长"
          >
            <el-option
              v-for="(v, i) in userArr"
              :key="i"
              :label="v.name"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="说明">
          <el-input
            type="textarea"
            placeholder="请输入说明"
            v-model="addOrEditForm.desc"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="addOrEditVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="handleSure('addOrEditForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
import store from "../../store";
export default {
  components: {
    breadcrumbs,
    btns,
  },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      form: {},
      tableData: [],
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 20, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      multipleSelection: [],
      funTit: null,
      addOrEditVisible: false,
      addOrEditForm: { name: "", desc: "", leader: "" },
      rules: {
        name: [{ required: true, message: "请输入团队名称", trigger: "blur" }],
        leader: [{ required: true, message: "请选择组长", trigger: "change" }],
      },
      userArr: [],
    };
  },
  created() {
    this.getUserPull();
    this.getList();
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
  },
  methods: {
    handleDetail(row) {
      this.$router.push({
        path: "/staff/sellTeam/teamDetail",
        query: {
          id: row.id,
        },
      });
    },
    // 新增编辑确认按钮
    handleSure(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          this.userArr.forEach((v) => {
            if (this.addOrEditForm.leader == v.id) {
              this.addOrEditForm.leaderName = v.name;
            }
          });
          if (this.funTit == "add") {
            handleConfirm("确认新增该团队吗?", "info")
              .then(() => {
                this.$api.sellTeam
                  .teamAdd({
                    departmentName: this.addOrEditForm.name,
                    groupId: this.addOrEditForm.leader,
                    groupName: this.addOrEditForm.leaderName,
                    remark: this.addOrEditForm.desc,
                  })
                  .then((res) => {
                    if (res.code === 200) {
                      handleAlert("团队新增成功", "success");
                      this.getList();
                      this.addOrEditVisible = false;
                    }
                  });
              })
              .catch(() => {
                return;
              });
          } else {
            handleConfirm("确认编辑该团队吗?", "info")
              .then(() => {
                this.$api.sellTeam
                  .teamEdit({
                    departmentName: this.addOrEditForm.name,
                    groupId: this.addOrEditForm.leader,
                    groupName: this.addOrEditForm.leaderName,
                    remark: this.addOrEditForm.desc,
                    id: this.multipleSelection[0].id,
                  })
                  .then((res) => {
                    if (res.code === 200) {
                      handleAlert("团队编辑成功", "success");
                      this.getList();
                      this.addOrEditVisible = false;
                    }
                  });
              })
              .catch(() => {
                return;
              });
          }
        } else {
          return false;
        }
      });
    },
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.sellTeam
        .teamList({
          pageNum: this.page,
          pageSize: this.pageSize,
          departmentName: this.form.name,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
          groupName: this.form.leader,
        })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          }
        });
    },
    update() {
      if (this.multipleSelection.length !== 1) {
        handleAlert("请选择一条数据", "error");
        return;
      }
      this.addOrEditForm = {
        name: this.multipleSelection[0].departmentName,
        desc: this.multipleSelection[0].remark,
        leader: Number(this.multipleSelection[0].groupId),
      };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.addOrEditForm.clearValidate();
      });
      this.addOrEditVisible = true;
    },
    add() {
      this.addOrEditForm = { name: "", desc: "", leader: "" };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.addOrEditForm.clearValidate();
      });
      this.addOrEditVisible = true;
    },
    getUserPull() {
      this.$api.zone.peoplePull().then((res) => {
        if (res.code === 200) {
          this.userArr = res.data.list;
        }
      });
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    },
    // 表格多选发生改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
};
</script>

<style lang="scss" scoped></style>
